var plugin_rtlignore_default = {
  "alignLeft": "JkuRh",
  "textWrapNowrap": "fc-28",
  "alignRight": "KpWSD",
  "alignCenter": "x0bE5",
  "sizeFullWidth": "cxyKH",
  "renderedInTable": "jxGUG",
  "sizeOriginal": "xPptP",
  "sizeContent": "eQqBP",
  "sizeSmall": "q-nJj",
  "sizeSmallCenter": "vTXKU",
  "flex": "hfW53",
  "atomic": "ZgtBK",
  "embed": "-Z36o",
  "horizontalScrollbar": "iC-W-",
  "pluginContainerMobile": "thoUh"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
